/* eslint-disable no-unused-vars */
import { createDefaultBooking } from '../../../services/customer/ticketBookingServices';

export default async function createDefaultStatement({
  departureClassesForm,
  returnClassesForm,
  guid,
  bookingData,
}) {
  const data = {
    statementGuid: guid,
    statementRides: [],
  };

  const departureClasses = departureClassesForm.getFieldValue('classes');

  const departureRide = {
    rideId: bookingData?.departure?.id,
    startStationCode: bookingData?.departure?.startStation?.code,
    endStationCode: bookingData?.departure?.endStation?.code,
    statementSeatClasses: [],
    seatGroupProperties: [],
  };

  departureClasses
    ?.filter(({ amount }) => amount > 0)
    ?.forEach((departureClass) => {
      if (departureClass?.seatGroupProperty?.id) {
        departureRide.seatGroupProperties.push({
          seatGroupPropertyId: departureClass?.seatGroupProperty?.id,
          seatClassId: departureClass?.id,
          passangersNumbers: departureClass?.amount,
        });
      } else {
        departureRide.statementSeatClasses.push({
          seatClassId: departureClass?.id,
          passangersNumbers: departureClass?.amount,
        });
      }
    });

  data.statementRides.push(departureRide);

  if (returnClassesForm) {
    const returnClasses = returnClassesForm.getFieldValue('classes');

    const returnRide = {
      rideId: bookingData?.return?.id,
      startStationCode: bookingData?.return?.startStation?.code,
      endStationCode: bookingData?.return?.endStation?.code,
      statementSeatClasses: [],
      seatGroupProperties: [],
    };

    returnClasses
      ?.filter(({ amount }) => amount > 0)
      ?.forEach((returnClass) => {
        if (returnClass?.seatGroupProperty?.id) {
          returnRide.seatGroupProperties.push({
            seatGroupPropertyId: returnClass?.seatGroupProperty?.id,
            seatClassId: returnClass?.id,
            passangersNumbers: returnClass?.amount,
          });
        } else {
          returnRide.statementSeatClasses.push({
            seatClassId: returnClass?.id,
            passangersNumbers: returnClass?.amount,
          });
        }
      });

    data.statementRides.push(returnRide);
  }
  return createDefaultBooking(data);
}
